import {
  Method,
  useNetwork,
} from "../../../internal-api/network/use-network.hook"

interface Response {
  result: string
  error?: {
    name: string
  }
}

const useSendMissingPhoneRequest = (): {
  pending: boolean
  sendRequest: (
    phoneModel: string,
    email: string
  ) => Promise<Record<string, any>>
} => {
  const [{ loading: pending }, fetch] = useNetwork<Response>({
    url: process.env.GATSBY_SAR_CHECKER_GOOGLE_SCRIPT_URL!,
    method: Method.Post,
  })

  const sendRequest = (phoneModel: string, email: string) => {
    const data = new FormData()
    data.append("phoneModel", phoneModel)
    data.append("email", email)

    return fetch({ data })
      .then(({ data: { error, ...response } }) => {
        if (error) {
          throw new Error(error.name)
        }
        return response
      })
      .catch((error) =>
        window.Rollbar.error(`Submit in TellUsModal failed, error: ${error}`)
      )
  }

  return { pending, sendRequest }
}

export default useSendMissingPhoneRequest
